const PlayIcon = ({ width = '24', height = '24', color = "#111" }) => {
    return (

        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            color={color}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-play-icon lucide-circle-play">
            <path d="M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z" />
            <circle cx="12" cy="12" r="10" />
        </svg>
    )
}

export default PlayIcon;